import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { BlogPostProps } from "@/pages/blog/components/BlogPost.tsx";
import { Box, LinkTo, Stack, Title } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

export function BlogPostHeader({ post, mode }: BlogPostProps) {
  const { renderEmployeeName, renderRelativeDate } = useFormatter();
  const { channel_id } = useParams();
  const channelId = channel_id ? Number(channel_id) : undefined;
  const currentChannels = useMemo(() => {
    if (channelId) return post?.channels.find((channel) => channel.id === channelId);
    if (post?.channels && post?.channels.length > 0) return post.channels[0];
  }, [channelId, post]);

  return (
    <Stack gap={"smd"} direction={"horizontal"} items={"center"} className={"relative"}>
      {!post.is_read && (
        <Box className={"w-2 h-2 bg-new rounded-full absolute top-1 right-0"}></Box>
      )}
      {post.author &&
        (mode != "preview" ? (
          <LinkTo to={`/employees/${post.author.id}`} className={"no-underline"}>
            <EmployeeAvatar employee={post.author} size={"lg"} />
          </LinkTo>
        ) : (
          <EmployeeAvatar employee={post.author} size={"lg"} />
        ))}
      <Title
        header={post.author ? renderEmployeeName(post.author) : ""}
        size={"sm"}
        caption={`${currentChannels ? `${currentChannels.title} · ` : ""}${renderRelativeDate(post.datetime_published_at ?? post.datetime_created_at)}`}
      ></Title>
    </Stack>
  );
}
